import { useCallback } from 'react';

import { getStaticAssetUrl } from '@change-corgi/core/assets';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

export function useGetStaticAssetUrl(): (pathname: string) => string {
	const { environment } = useUtilityContext();
	const env = environment.getApiSubEnvironment();
	return useCallback((pathname: string) => getStaticAssetUrl(env, pathname), [env]);
}

export function useStaticAssetUrl(pathname: string): string {
	return useGetStaticAssetUrl()(pathname);
}
